import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './not-found.component';
import { SharedModule } from '@shared/shared';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';

export const routes: Routes = [
  {
    path: '',
    component: PageNotFoundComponent,
    data: {
      title: 'pageNotFound.routeTitle',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), SharedModule, TranslocoModule],
  exports: [RouterModule],
  declarations: [PageNotFoundComponent],
})
export class PageNotFoundModule {
  constructor(private translocoService: TranslocoService) {
    registerTranslationsManually('pageNotFound', this.translocoService, import.meta.webpackContext!('./translation'));
  }
}
